module.exports = __webpack_public_path__ + "static/img/dadiType2.1e3b479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadiType2.jpg
// module id = 6eGy
// module chunks = 4